<template>
	<div>
		<dl class="opport-screen bdbe opport-screen-overflow-auto">
			<dt class="fl">{{oneLevelTitle}}</dt>
			<dd class="fl screenop">
				<span @click="chooseNotion(1,'a',{lable:'全部',value:0,children:[]})"
					:class="notionCode == 0 ?'a-screen current':'a-screen'"  v-show="isShowOneLevelTotal">全部</span>
				<span :key="index" v-for="(item,index) in notionlist"  
					:class="chooseNotionlist[0] == item.value ?'a-screen current':'a-screen'"
					@click="chooseNotion(1,'a',item)">{{item.label}}</span>
				<!-- 搜索框 -->
				<div class="sider-left por" v-if="isShowNotionScreen">
					<div class="area-bar" style="height: 32px;">
						<div class="search-bar">
							<!--  @blur="showSearchResult=false" -->
							<el-input class="search-text" ref="elSearch" clearable 
							prefix-icon="el-icon-search" placeholder="请输入产业关键词"  v-model="searchWord"></el-input>
							<!-- <button class="search-btn" @click="searchEnterprise"><i slot="suffix"  @keyup.enter.native="searchEnterprise" 	@keyup="searchEnterprise" 
									class="el-input__icon el-icon-search"></i>查询</button> -->
						</div>
					</div>
					<div class="view-bar box-shadow" v-show="showSearchResult">
						<div class="box-card search-result">
							<!-- <div class="header clearfix">
								<span><span class="kw red-font-1">{{ searchWord}}</span> 共搜索到 <span
										class="num">{{ searchList.length }}</span>条概念搜索结果</span>
								<i @click="closeSearchBar" style="float: right; margin-top:5px;" class="el-icon-close"
									type="text"></i>
							</div> -->
							<div class="cont cont2">
								<div class="item" @click="onSelectItem(item)" v-for="(item,index) in searchList" :key="index">
									<!-- <strong class="code-f red-font-1">{{item.value}}</strong> -->
									<p class="title"  v-html="formatSearchTitle(item.label)"></p> 
								</div>
							</div>
						</div>
					</div>
				</div>
			</dd>
		</dl>
		<dl class="opport-screen bdbe" v-show="notionlist1.length>0 && showLevelNum>1">
			<dt class="fl titleop">一级产业</dt>
			<dd class="fl">
				<span @click="chooseNotion(2,'all',fenkd)"
					:class="chooseNotionlist[1]==0 ?'a-screen current':'a-screen'">全部</span>
				<span :key="index" v-for="(item,index) in notionlist1"
					:class="chooseNotionlist[1] == item.value ?'a-screen current':'a-screen'"
					@click="chooseNotion(2,'a',item)">{{item.label}}<em class="num" v-show="!searchNotionBtn && item.num && item.num>0">({{item.num}})</em></span>
			</dd>
		</dl>
		<dl class="opport-screen bdbe" v-show="notionlist2.length>0 && showLevelNum>2">
			<dt class="fl titleop">二级细分</dt>
			<dd class="fl">
				<span @click="chooseNotion(3,'all',fenkd)"
					:class="chooseNotionlist[2]==0 ?'a-screen current':'a-screen'">全部</span>
				<span :key="index" v-for="(item,index) in notionlist2"
					:class="chooseNotionlist[2] == item.value ?'a-screen current':'a-screen'"
					@click="chooseNotion(3,'a',item)">{{item.label}}<em class="num" v-show="!searchNotionBtn && item.num && item.num>0">({{item.num}})</em></span>
			</dd>
		</dl>
		<dl class="opport-screen bdbe" v-show="notionlist3.length>0 && showLevelNum>3">
			<dt class="fl titleop">三级细分</dt>
			<dd class="fl">
				<span @click="chooseNotion(4,'all',fenkd)"
					:class="chooseNotionlist[3]==0?'a-screen current':'a-screen'">全部</span>
				<span :key="index" v-for="(item,index) in notionlist3"
					:class="chooseNotionlist[3] == item.value ?'a-screen current':'a-screen'"
					@click="chooseNotion(4,'a',item)">{{item.label}}</span>
			</dd>
		</dl>
		<dl class="opport-screen bdbe" v-show="notionlist4.length>0 && showLevelNum>4">
			<dt class="fl titleop">四级细分</dt>
			<dd class="fl">
				<span @click="chooseNotion(5,'all',fenkd)"
					:class="chooseNotionlist[4]==0 ?'a-screen current':'a-screen'">全部</span>
				<span :key="index" v-for="(item,index) in notionlist4"
					:class="chooseNotionlist[4] == item.value ?'a-screen current':'a-screen'"
					@click="chooseNotion(5,'a',item)">{{item.label}}</span>
			</dd>
		</dl>

	</div>
</template>
<script>
	export default {
		name: 'zpagenav',
		data() {
			return {
				userdata: {},
				title: "概念的展示与搜索",
				notiontext: '',
				notionCode: 0,
				chooseNotionlist: [0, 0, 0, 0, 0],
				chooseNotionTextlist:['','','','','',''],
				notionlistDefault: [],
				notionStep:1,
				notionlist: [],
				notionlist1: [],
				notionlist2: [],
				notionlist3: [],
				notionlist4: [],
				notionlist5: [],
				notionlist6: [],
				fenkd: {
					children: []
				},
				//概念搜索专用
				searchWord: '',
				showSearch: true,
				showSearchResult: false,
				searchList: [],
				searchTimerId: 0,
				viewList: [],
				searchNotionBtn:false, 
			}
		},
		watch:{
			searchWord(){
				this.searchEnterprise();
			},
			notionNumberList:{
				handler(newValue,oldValue){ 
					console.log('notionNumberList',newValue);
					this.notionNumberList=newValue;  
					this.setnotionNumlist(this.notionNumberList);
				}  
			},
			// isClearNotion:{
			// 	handler(newval,oldval){
			// 		this.isClearNotion=newval;
			// 		if(this.isClearNotion){
			// 			this.clearNotionResult();
			// 		}
			// 	}
			// },
			refreshNum:{
				handler(newval,oldval){
					this.refreshNum=newval; 
					if(this.isClearNotion){
						this.clearNotionResult();
					}
				}
			},
			// refreshNum:{
			// 	handler(newValue,oldValue){
			// 		// console.log('newValue',newValue)
			// 		console.log('refreshNum',this.notionNumlist);
			// 		var testarry=[{value:"dddd",label:'测试专用',children:[]}];
			// 		// this.setnotionNumlist(this.notionNumlist);
			// 		if(this.notionStep == 1){
			// 			this.notionlist1 =  this.notionNumlist ? this.notionNumlist : testarry;
			// 		}else if(this.notionStep == 2){
			// 			this.notionlist2 =  this.notionNumlist ? this.notionNumlist : testarry;
			// 		}
			// 		this.refreshNum=newValue;  
			// 	}  
			// }, 
		},
		props: {
			type: { type: Number, default: 1 }, //入口 1 为后台获取数据 2为列表页获取数据后存入数据 会有数字
			notionNumberList: {type: Array}, //type=2时传入的概念数字列表
			refreshNum:{ type: Number,default:1, },//部分筛选项需要带数字排序 刷新数字 
			isShowNotionScreen:{ type: Boolean,default:false, },//是否展示概念搜索框
			token: {type: String, default: "" },
			isClearNotion:{type:Boolean,default:false},//全部企业概念搜索城市时需要还原概念筛选
			oneLevelTitle:{type: String, default: '产业分类'},//产业分类的标题文字
			isShowOneLevelTotal:{type: Boolean, default: true},//是否展示产业分类的全部选项
			showLevelNum:{type: Number, default: 5},//细分的等级
		},
		created() { 
			this.ajaxGetNotionList();
		},
		mounted() {
			
		},
		methods: {
			//三大产业概念数据
			ajaxGetNotionList() {
				var _this = this;
				this.$axios.get(this.$api.tag.notion.list() + '?level=5', {
					headers: {
						AuthToken: this.token
					}
				}).then(function(res) {
					if (res.data.success) {
						_this.notionlist = res.data.list;
						_this.notionlistDefault=res.data.list;
						for(var i=0;i<_this.notionlist.length;i++){ 
							_this.notionlist[i].parentList=[_this.notionlist[i].value];
							if(_this.notionlist[i].value == 'A'){
								 _this.notionlist[i].children=_this.notionlist[i].children.filter(lists=>{
										return lists.label != '环保'  ;
									})
							}
						} 
						_this.notionlist=_this.notionlist.filter((list=>{
							return list.label.indexOf('未来')<0;
						}))
						_this.chooseNotionlist=_this.isShowOneLevelTotal?[0,0,0,0,0]:['A',0,0,0,0,0];
						_this.notionCode=_this.isShowOneLevelTotal?0:'A';
						_this.notionlist1=_this.isShowOneLevelTotal?[] :_this.notionlist[0].children;
					 
						// _this.getNotionStr(res.data.list);
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},  
			// 递归搜索方法
			filterTree(val, tree, newArr = []) {
				if (!(tree.length && val)) { // 如果搜索关键字为空直接返回源数据
					return tree
				} 
				for (let item of tree) { 
					if (item.label.indexOf(val) > -1) { // 匹配到关键字的逻辑
						newArr.push(item) // 如果匹配到就在数值中添加记录 
						continue // 匹配到了就退出循环了此时如果有子集也会一并带着 
					} 
					if (item.children && item.children.length) { // 如果父级节点没有匹配到就看看是否有子集，然后做递归 
					for (let smitem of item.children) {
						smitem.parentList=[smitem.value];
						if(item.parentList){
								// smitem.parentList=item.parentList.push(item.value); 
								smitem.parentList=item.parentList.concat(smitem.parentList);
						} 
					}
						let subArr = this.filterTree(val, item.children) // 缓存递归后的子集数组 
						if (subArr && subArr.length) { // 如果子集数据有匹配到的节点 
							let node = {
								...item,
								children: subArr
							} // 关键逻辑，缓存父节点同时将递归后的子节点作为新值 
							newArr.push(node) // 添加进数组 
						} 
					} 
				} 
				if(newArr.length>0){
					this.searchList=this.searchList.concat(newArr);
					// console.log('newArr',newArr,this.searchList) ;
				} 
			}, 
			//根据code长度排序
			sortCodeLength(array){    				//正序从小到大
				return array.sort(function(a,b){
					var x = a.value.length;
					var y = b.value.length; 
					return ((x<y)?-1:(x>y)?1:0)
				})
			},
			//概念单选 层级显示
			chooseNotion(step, type, data) {
				var siblingsList=[];
				this.notionStep=step;
				this.searchNotionBtn=false;
				if (type == 'all') {
					this.notionCode = this.chooseNotionlist[step - 2];
					this.notiontext = this.chooseNotionTextlist[step - 2];
					this.chooseNotionlist[step - 1] = '0';
					this.chooseNotionTextlist[step - 1] = '';
				} else {
					this.chooseNotionlist[step - 1] = data.value;
					this.chooseNotionTextlist[step - 1] = data.label;
					for (var i = 0; i < this.chooseNotionlist.length; i++) {
						if (i > step - 1) {
							this.chooseNotionlist[i] = '0';
							this.chooseNotionTextlist[i] = '';
						}
					}
					this.notionCode = data.value;
					this.notiontext = data.label;
				}
				if (data.children != null) {
					if (step == 1) { 
						this.notionlist1 = data.children.filter(list => {
							return list.label != '环保';
						});  
						this.notionlist2 = [];
						this.notionlist3 = [];
						this.notionlist4 = [];
					} else if (step == 2) { 
						this.notionlist2 = data.children; 
						this.notionlist3 = [];
						this.notionlist4 = [];
					} else if (step == 3) {
						this.notionlist3 = data.children;
						this.notionlist4 = [];
					} else if (step == 4) {
						this.notionlist4 = data.children;
						this.notionlist5 = [];
					} else if (step == 5) {
						this.notionlist5 = data.children;
					}
				}
				// console.log(this.chooseNotionlist); 
				this.closeSearchBar(); 
				this.$emit('chooseNotion', this.chooseNotionlist, this.notionCode,step,this.notiontext); 
			},
			//选中搜索后的概念
			onSelectItem(data) { 
				console.log('选中搜索后的概念',data);
				this.notionCode=data.value;
				this.notiontext=data.label;
				this.chooseNotionlist=data.parentList;
				this.searchNotionBtn=true;
				for(var i=0;i<data.parentList.length - 1;i++){
					console.log(data.parentList[i])
					this.slideNotionList(i+1,data.parentList[i]);
				}
				// this.showSearchResult=false;
				this.closeSearchBar();
				this.$emit('chooseNotion', this.chooseNotionlist, this.notionCode,null,this.notiontext); 
			},
			//筛选概念后逐层打开  层级显示
			slideNotionList(step,parentcode) { 
				if (step == 1) {
					var list2 = this.notionlistDefault.filter(list=>{
						return list.value == parentcode;
					}); 
					this.notionlist1 =list2[0].children;
					// console.log(this.notionlist1)
					this.notionlist2 = [];
					this.notionlist3 = [];
					this.notionlist4 = [];
				} else if (step == 2) {
					var list2 = this.notionlist1.filter(list=>{
						return list.value == parentcode;
					});
					this.notionlist2=list2[0].children;
					this.notionlist3 = [];
					this.notionlist4 = [];
				} else if (step == 3) {
					var list2 = this.notionlist2.filter(list=>{
						return list.value == parentcode;
					});
					this.notionlist3=list2[0].children; 
					this.notionlist4 = [];
				} else if (step == 4) {
					var list2 = this.notionlist3.filter(list=>{
						return list.value == parentcode;
					});
					this.notionlist4=list2[0].children;  
					this.notionlist5 = [];
				} else if (step == 5) {
					var list2 = this.notionlist4.filter(list=>{
						return list.value == parentcode;
					});
					this.notionlist5=list2[0].children;   
				} 
				// console.log(this.chooseNotionlist);
			
			},
			//概念搜索 
			searchEnterprise(kw) {
				// clearTimeout(this.searchTimerId); 
				this.showSearchResult = this.searchWord != '';
				if (this.showSearchResult) {
					this.searchList=[];
					// this.searchList = this.list.filter(x => x.title.indexOf(kw) >= 0);
					this.filterTree(this.searchWord,this.notionlist);
					this.searchList=this.sortCodeLength(this.searchList);
					console.log('拼接的搜索信息',this.searchList) 
				} 
			},
   //后台将有数量的概念传回来后需要和当前的概念列表进行穿插
			setnotionNumlist(citynotionlist){
				if(this.notionStep>2){
					return;
				}
				var zancunNlist=[],citynotionlist1 = [];
				if(this.notionStep == 1){
					zancunNlist=this.notionlist1;
				}else if(this.notionStep == 2){
					zancunNlist=this.notionlist2;
				} 
				for (var i = 0; i < citynotionlist.length; i++) {
					for (var d = 0; d < zancunNlist.length; d++) {
						if (citynotionlist[i].notionCode == zancunNlist[d].value) {
							citynotionlist[i].children = zancunNlist[d].children;
							citynotionlist[i].label = zancunNlist[d].label;
							citynotionlist[i].value = zancunNlist[d].value;
							citynotionlist1.push(citynotionlist[i]);
							break;
						}
					}
				}
				// console.log(zancunNlist,citynotionlist) 
				if (this.notionStep == 1) { 
					this.notionlist1 = citynotionlist1; 
				} else if (this.notionStep == 2) {
					this.notionlist2 = citynotionlist1;
				}  
			},
			//将搜索标题变红  
			formatSearchTitle(title) {
				return title.replace(this.searchWord, '<span class="red-font-1">' + this.searchWord + '</span>');
			},
			//清空搜索内容 关闭搜索框
			closeSearchBar() {
				this.showSearch = false;
				this.showSearchResult = false;
				this.searchWord = '';
				this.searchList = [];
				// this.setViewList();
			},
			//清空已选概念 
			clearNotionResult(){
				
				this.chooseNotionlist=this.isShowOneLevelTotal?[0,0,0,0,0]:['A',0,0,0,0,0];
				this.notionCode=this.isShowOneLevelTotal?0:'A';
				this.notionlist1=this.isShowOneLevelTotal?[] :this.notionlist[0].children;
				
				// this.notionlist1 = [];
				this.notionlist2 = [];
				this.notionlist3 = [];
				this.notionlist4 = [];
				this.notionlist5 = [];
				// this.notionCode = 0;
				// this.chooseNotionlist = [0, 0, 0, 0, 0, 0];
			},
			// enterSearchIcon() {
			// 	//console.log('enter');
			// 	this.showSearch = true;
			// 	setTimeout(() => {
			// 		this.$refs.elSearch.focus();
			// 	}, 500);
			// },
			// leaveSearchIcon() {
			// 	//console.log('leave');
			// 	this.showSearch = this.showSearchResult || false;
			// },
			// toggleViewbar() {
			// 	this.showViewbar = !this.showViewbar;
			// },
			// setViewList() {
			// 	if (!this.list || this.length == 0 || this.showSearchResult) {
			// 		return;
			// 	}
			// 	//var mapUtil = this.$refs.bgmap.getMapUtil();
			// 	this.viewList = this.mapUtil.getViewList(this.list);
			// 	this.$refs.bgmap.setData(this.viewList);
			// 	this.changePage(1);
			// 	this.mapTotal = this.viewList.length;
			// },
			// changePage(page) {
			// 	this.mapPage = page;
			//  var start = (page - 1) * this.mapPageSize;
			// 	var end = start + this.mapPageSize;
			// 	this.mapPageList = this.viewList.filter((o, i) => i >= start && i < end);
			// 	//console.log(this.pageList);
			// },
			// setSearchList() {
			// 	this.$refs.bgmap.setSearchData(this.searchList);
			// },
		},

	}
</script>

<style lang="scss" scoped>
	.sider-left {
		float: left;
		font-size: 14px;
		text-align: left;
		width: 380px;
		color: #000;
	}

	.area-bar {
		padding: 0 10px;
		position: relative;

		.count {
			margin: 0 10px;
		}

		.search-icon {
			float: right;
			margin-top: 7px;
			margin-right: 6px;
			font-size: 18px;

			&:hover {
				color: #39f;
			}
		}

		.el-icon-close {
			font-size: 18px;
		}

		.el-input__icon.el-icon-search {
			width: 18px;
			color: #5E83CC;
		}

		.search-bar {
			position: absolute;
			left: 0;
			top: 0;
			width: 98%;
			height: 100%;

			//display:none;
			.search-text {
				margin: 5px 4px;
				width: 300px;
			}

			.search-btn {
				width: 60px;
				color: #5E83CC;

			}
		}
	}

	.view-bar {
		position: absolute;
		left:4px;
		top: 44px;
		width: 300px;
		height: auto;
		z-index: 10;
		background: #fff;

		.box-card {
			.header {
				padding: 15px 20px;
			} 
			.cont {
				padding: 5px 0;
				border-top: 1px solid #eee;
				height: 300px;
				overflow-y: scroll;

				.item {
					cursor: default;
					padding: 10px 20px;
					overflow: hidden;
					cursor: pointer;
					&:hover{
						background: #eee; 
					}
				}
				.code-f{
					float: left;width: 80px;
				}
				.title{
					 width: 100%;height: auto;
				}
				// .active {
				// 	background: #eee; 
				// 	.title {
				// 		color: #f50;
				// 	}
				// }
			}

			.title {
				font-size: 16px; 
				font-weight: bold;
				color: rgba(9, 22, 49, 0.842);
			}

			.addr {
				font-size: 12px;
				color: #555;
				border-bottom: 1px solid #eee;
				padding: 5px 0 10px;
			}
		}

		.pagination {
			padding: 10px 0;
		}
	}
</style>